import { render, staticRenderFns } from "./HtmlEditor.vue?vue&type=template&id=2524b9fe"
import script from "./HtmlEditor.vue?vue&type=script&lang=js"
export * from "./HtmlEditor.vue?vue&type=script&lang=js"
import style0 from "./HtmlEditor.vue?vue&type=style&index=0&id=2524b9fe&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2524b9fe')) {
      api.createRecord('2524b9fe', component.options)
    } else {
      api.reload('2524b9fe', component.options)
    }
    module.hot.accept("./HtmlEditor.vue?vue&type=template&id=2524b9fe", function () {
      api.rerender('2524b9fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Inputs/HtmlEditor.vue"
export default component.exports